import { render } from "./OperationsPayments.vue?vue&type=template&id=6dc56d24"
import script from "./OperationsPayments.vue?vue&type=script&lang=js"
export * from "./OperationsPayments.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__